import { createSlice } from '@reduxjs/toolkit';

// Define action types as strings within the slice
const ADD_NEW_ADVANCE_REQUEST = 'advanceData/ADD_NEW_ADVANCE_REQUEST';
const ADD_NEW_ADVANCE_SUCCESS = 'advanceData/ADD_NEW_ADVANCE_SUCCESS';
const ADD_NEW_ADVANCE_FAILURE = 'advanceData/ADD_NEW_ADVANCE_FAILURE';

const FETCH_ADVANCE_DATA_REQUEST = 'advanceData/FETCH_ADVANCE_DATA_REQUEST';
const FETCH_ADVANCE_DATA_SUCCESS = 'advanceData/FETCH_ADVANCE_DATA_SUCCESS';
const FETCH_ADVANCE_DATA_FAILURE = 'advanceData/FETCH_ADVANCE_DATA_FAILURE';

const FETCH_ADVANCE_BY_EMPLOYEE_ID_REQUEST = 'advanceData/FETCH_ADVANCE_BY_EMPLOYEE_ID_REQUEST';
const FETCH_ADVANCE_BY_EMPLOYEE_ID_SUCCESS = 'advanceData/FETCH_ADVANCE_BY_EMPLOYEE_ID_SUCCESS';
const FETCH_ADVANCE_BY_EMPLOYEE_ID_FAILURE = 'advanceData/FETCH_ADVANCE_BY_EMPLOYEE_ID_FAILURE';

const DELETE_ADVANCE_REQUEST = 'advanceData/DELETE_ADVANCE_REQUEST';
const DELETE_ADVANCE_SUCCESS = 'advanceData/DELETE_ADVANCE_SUCCESS';
const DELETE_ADVANCE_FAILURE = 'advanceData/DELETE_ADVANCE_FAILURE';

const initialState = {
    isLoading: false,
    advanceData: [],
    editingAdvance: null,
    loadingAdd: false,
    errorAdd: null,
    loaderMessage: '',
    loadingFetch: false,
    errorFetch: null,  
    loadingFetchById: false,
    errorFetchById: null, 
    loadingUpdate: false, 
    errorUpdate: null, 
    employeeAdvance: null, 
    errorFetchEmployeeAdvance: null,
};

const advanceDataSlice = createSlice({
    name: 'advanceData',
    initialState,
    reducers: {

        // add data 
        addNewAdvanceRequest: (state) => {
            state.loadingAdd = true;
            state.loaderMessage = 'Loading please wait...'
            state.errorAdd = null;
        },
        addNewAdvanceSuccess: (state, action) => {
            state.advanceData = [action.payload, ...state.advanceData];
            state.loadingAdd = false;
        },
        addNewAdvanceFailure: (state, action) => {
            state.loadingAdd = false;
            state.errorAdd = action.payload;
        },

        // fetch data 
        fetchAdvanceDataRequest: (state) => {
            state.loadingFetch = true;
            state.isLoading = true; 
            state.errorFetch = null;
        },
        fetchAdvanceDataSuccess: (state, action) => {
            state.advanceData = action.payload;
            state.loadingFetch = false;
            state.isLoading = false;
        },
        fetchAdvanceDataFailure: (state, action) => {
            state.loadingFetch = false;
            state.isLoading = false;
            state.errorFetch = action.payload;
        },
        startAdvanceOnlyBasicFecth: (state, action) => {
            state.loadingFetchById = true;
            state.errorFetchById = null;
            state.editingAdvance = null; 
        },

        // fetch data 
        fetchAdvanceByIdSuccess: (state, action) => {
            state.loadingFetchById = false;
            state.editingAdvance = action.payload;
        },
        fetchAdvanceByIdFailure: (state, action) => {
            state.loadingFetchById = false;
            state.errorFetchById = action.payload;
        },


        // clear data 
        clearEditingAdvance: (state) => {
            state.editingAdvance = null;
        },

        // update data 
        updateExistingAdvanceRequest: (state, action) => { // New action
            state.loadingUpdate = true;
            state.errorUpdate = null;
        },
        updateExistingAdvanceSuccess: (state, action) => { // New action
            state.loadingUpdate = false;
            state.advanceData = state.advanceData.map(advance =>
                advance.id === action.payload.id ? action.payload : advance
            );
            state.editingAdvance = null;
        },
        updateExistingAdvanceFailure: (state, action) => { 
            state.loadingUpdate = false;
            state.errorUpdate = action.payload;
        },

        // delete data 
        startDeleteAdvance: (state, action) => {
            state.isLoading = true;
            state.loaderMessage = 'Deleting advance...';
            state.errorFetch = null;
        },
        deleteAdvanceSuccess: (state, action) => {
            state.isLoading = false;
            state.advanceData = state.advanceData.filter(advance => advance.id !== action.payload);
        },
        deleteAdvanceFailure: (state, action) => {
            state.isLoading = false;
            state.errorFetch = action.payload;
        },

        // filter data  
        fetchAdvanceDataByFilterRequest: (state) => {
            state.loadingFetch = true;
            state.isLoading = true;
            state.errorFetch = null;
        },
        fetchAdvanceDataByFilterSuccess: (state, action) => {
            state.advanceData = action.payload[0] || []; // Adjust based on your API response structure
            state.totalCount = action.payload[1]?.[0]?.total_count || 0;
            state.loadingFetch = false;
            state.isLoading = false;
        },
        fetchAdvanceDataByFilterFailure: (state, action) => {
            state.loadingFetch = false;
            state.isLoading = false;
            state.errorFetch = action.payload;
        },
        
    },
});

// Export action creators
export const {
    addNewAdvanceRequest,
    addNewAdvanceSuccess,
    addNewAdvanceFailure,
    fetchAdvanceDataRequest,
    fetchAdvanceDataSuccess,
    fetchAdvanceDataFailure,
    startAdvanceOnlyBasicFecth,
    fetchAdvanceByIdSuccess,
    fetchAdvanceByIdFailure,
    clearEditingAdvance,
    updateExistingAdvanceRequest,
    updateExistingAdvanceSuccess,
    updateExistingAdvanceFailure,

    startDeleteAdvance,
    deleteAdvanceSuccess,
    deleteAdvanceFailure,

    fetchAdvanceDataByFilterRequest,
    fetchAdvanceDataByFilterSuccess,
    fetchAdvanceDataByFilterFailure,

    
} = advanceDataSlice.actions;

// Export the reducer
export default advanceDataSlice.reducer;

// Export selectors
export const advanceDataSelector = (state) => state.AdvanceData.advanceData;
export const isLoadingSelector = (state) => state.AdvanceData.isLoading || state.AdvanceData.loadingFetch; 
export const loadingAddSelector = (state) => state.AdvanceData.loadingAdd;
export const errorAddSelector = (state) => state.AdvanceData.errorAdd;
export const loaderMessageSelector = (state) => state.advanceData.loaderMessage;
export const errorFetchSelector = (state) => state.AdvanceData.errorFetch;
export const editingAdvanceSelector = (state) => state.AdvanceData.editingAdvance;
export const isLoadingFetchByIdSelector = (state) => state.AdvanceData.loadingFetchById;
export const errorFetchByIdSelector = (state) => state.AdvanceData.errorFetchById;
export const errorUpdateSelector = (state) => state.AdvanceData.errorUpdate;  
